import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
  RadioGroup,
} from '@mui/material';
import { Select, MenuItem } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  getInvestorReportsLevel,
  getReportSelectionList,
  getClientL3L4_Config,
  getAcountIDBasedonClientID,
} from '../../redux-store/actions/investorReports';
import {
  downloadMultipleFiles,
  formatDate,
  replaceLetterOWithW,
} from '../../utils/utilityFunctions';
import { BpRadio, ReportSectionContainer, ReportsRightLayout } from './index';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import FormMultiSelect from '../../lib/formik/FormMultiSelect';
import { MFSubmitButton } from '../../lib/formik';
import { validationSchemaClientStatement } from '../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import {
  getInvestorData,
  getRMDashBoardMetrics,
  getRmRedirectionLink,
} from '../../redux-store/actions/userManagement';
import { AcountIDBasedonClientIDResponse, ClientL3L4_ConfigResponse } from '../../redux-store/types/api-types'
import {
  InvestorDetailEntity,
  RmDashboardType,
  RmRedirectionLinkType,
} from '../../redux-store/types/api-types';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { reportData } from '../Reports/report-utils';
import { ColumnType } from '../DataTable';
import Swal from 'sweetalert2';

const ClientStatement = ({
  location }: {
    location: Location<{ investorId: string; investorName: string }>
  }) => {
  const dispatch = useDispatch();
  const [reportSelection, setReportSelection] = useState<any>();
  const { enqueueSnackbar } = useSnackbar();
  const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  const history = useHistory();
  const currentDate = dayjs();
  const [loading, setLoading] = useState<boolean>(false);
  const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [cg_fromDates, setCg_fromDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [cg_toDates, setCg_toDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [dashBoardMetricsData, setDashBoardMetricsData] = useState<RmDashboardType | null>(null);
  const [investorData, setInvestorData] = useState<InvestorDetailEntity | null>(null);
  const [investorOptions, setInvestorOptions] = useState<any>([""]);
  const [l3l4Flag, setL3l4Flag] = useState<any>("N");
  const [wAccountIDFlag, setWAccountIDFlag] = useState<boolean>(false);
  const [wAccountsData, setWAccountsData] = useState<AcountIDBasedonClientIDResponse | null>();
  const [wAccountId, setWAccountId] = useState<any>(null);
  const [duration, setDuration] = useState<any>("AsOnDate");
  const [clientLevelReportFlag, setClientLevelReportFlag] = useState<boolean>(false);
  const options = [{ invName: investorData?.I_InvName }, { invId: investorData?.OClientID }]
  const options2 = [
    {
      header: 'Investor Name',
      value: (row: InvestorDetailEntity) => row.I_InvName,
    },]

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        const reportSelectionList = (await dispatch(getReportSelectionList())) as unknown as any[];
        const transformedRes = reportSelectionList.map((obj: any) => {
          return {
            label: obj.Name,
            value: obj.ID,
          };
        });
        if (!isComponentAlive) return;
        setReportSelection(transformedRes);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);

  useEffect(() => {
    if (!investorId) {
      let isComponentActive = true;
      setDashBoardMetricsData(null);
      (async function () {
        try {
          const response = (await dispatch(getRMDashBoardMetrics())) as RmDashboardType;
          if (!isComponentActive) {
            return;
          }
          setDashBoardMetricsData(response);
          setInvestorOptions(investorData?.I_InvName)
        } catch (e) {
          console.log((e as Error).message);
        }
      })();
      return () => {
        isComponentActive = false;
      };
    }
  }, [])

  useEffect(() => {
    if (investorId) {
      // API call to enable/disable Client Level Report Checkbox 
      const requestBody = {
        "ClientCode": investorId
      };
      (async function () {
        try {
          const response = (await dispatch(getClientL3L4_Config(requestBody)) as unknown as ClientL3L4_ConfigResponse);
          if (response.Table && response.Table.length > 0) {
            setL3l4Flag(response.Table[0].flag);
          }
        } catch (e) {
          console.log((e as Error).message);
        }
      })();

      setWAccountId(null);
      (async function () {
        try {
          const response = (await dispatch(getAcountIDBasedonClientID(requestBody)) as unknown as AcountIDBasedonClientIDResponse);
          if (response.OAccountID.length > 0) {

            // if W series account number is greater than 1 then it will show Select Account Dropdwmn
            // it will set wAccountId with useState by default first wAccountId
            if (response.OAccountID.length > 1) {
              setWAccountIDFlag(true);
            }
            setWAccountsData(response);
            setWAccountId(response.OAccountID[0]?.AccountIdentifier);

          }
          else {
            setWAccountIDFlag(false);
          }
        } catch (e) {
          console.log((e as Error).message);
        }
      })();
    }
  }, []);

  const onSubmit = async (values: any) => {
    try {
      if (wAccountIDFlag == true && !wAccountId) {
        Swal.fire({
          confirmButtonText: 'OK',

          icon: 'info',
          confirmButtonColor: 'rgb(32, 87, 166)',
          html: '<p>Please select Account Number!</p>',
          backdrop: false,
          focusCancel: true,
          allowEscapeKey: true,
        });
        return;
      }
      const { reportOptions, date, redeemedSchemesFlg, transactionHistoryFlg, cg_fromDate, cg_todate } = values;
      const formattedDate = `${new Date(date).getDate().toString().padStart(2, '0')}/${(new Date(date)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(date).getFullYear()}`;
      const formattedCg_fromDate = `${new Date(cg_fromDate).getDate().toString().padStart(2, '0')}/${(new Date(cg_fromDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(cg_fromDate).getFullYear()}`;
      const formattedCg_ToDate = `${new Date(cg_todate).getDate().toString().padStart(2, '0')}/${(new Date(cg_todate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(cg_todate).getFullYear()}`;

      const allIdValue = reportSelection.find(
        (option: { label: string; value: string }) => option.label.toLowerCase() === 'all'
      ).value;
      if (investorId) {
        setLoading(true)
        const res = await dispatch(
          getInvestorReportsLevel({
            //here if Client Level Report flag checked true then we send oSeries Account Number in clientId field
            // else we send wAccountId or investorId or empty string      
            clientId: [clientLevelReportFlag ? (investorId || '') :
              (wAccountId || investorId || '')],
            toDate: formattedDate,
            reportName: 'ClientStatement',
            HFlag: portfolio,
            reportConfig: {
              redeemedSchemesFlg: redeemedSchemesFlg.toString(),
              transactionHistoryFlg: transactionHistoryFlg.toString(),
              reportOptions:
                reportOptions.indexOf(allIdValue) !== -1 ? [allIdValue] : reportOptions,
            },
            level: clientLevelReportFlag ? "ClientStatement_L3L4" : "Individual",
            cg_fromDate: formattedCg_fromDate,
            cg_ToDate: formattedCg_ToDate,
            FlgBetweenDates_CG: duration == 'betweenDates' ? true : false,
          })
        );
        setLoading(false)
        downloadMultipleFiles(res);
        enqueueSnackbar('File(s) downloaded successfully.', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      setDates(dayjs(currentDate).format("YYYY-MM-DD"));
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  const [portfolio, setPortfolio] = useState<number>(1);
  const handleChange = (event: any) => {
    setPortfolio(event.target.value);
  };

  const handleAccountNumberChange = (event: any) => {
    setWAccountId(event.target.value);
  };
  return (
    <>
      <ReportsRightLayout>
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '19px',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            display: ['none', 'none', 'block'],
          }}>
          Client Statement
        </Typography>
        <Formik
          validationSchema={validationSchemaClientStatement}
          initialValues={{
            reportOptions: [],
            date: new Date(),
            redeemedSchemesFlg: 1,
            transactionHistoryFlg: 0,
            duration: "AsOnDate",
            cg_fromDate: new Date(),
            cg_todate: new Date(),
          }}
          onSubmit={onSubmit}>
          {({
            values,
            setFieldValue,
          }: {
            values: {
              reportOptions: number[];
              date: any;
              redeemedSchemesFlg: number;
              transactionHistoryFlg: number;
              duration: "AsOnDate";
            };
            setFieldValue: (
              field: string,
              value: any,
              shouldValidate?: boolean | undefined
            ) => void;
          }) => (
            <Form>
              <ReportSectionContainer>
                <Stack>
                  {l3l4Flag == "Y" && <FormControl component="fieldset" style={{ marginBottom: '1rem' }}>
                    <FormGroup aria-label="position">
                      <FormControlLabel
                        value="clientLevelReport"
                        checked={clientLevelReportFlag}
                        onChange={(_, checked) => {
                          setClientLevelReportFlag(!clientLevelReportFlag);
                        }}
                        control={<Checkbox />}
                        label="Client Level Report"
                        labelPlacement="end"
                        disabled={l3l4Flag === "N"}
                      />
                    </FormGroup>
                  </FormControl>}

                  {
                    wAccountIDFlag &&
                    <Stack>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 400,
                          lineHeight: '22px',
                          letterSpacing: '0.01em',
                        }}>
                        Account Number
                      </Typography>

                      <FormControl sx={{ m: 1, minWidth: 500 }}>
                        {/* <InputLabel id="demo-simple-select-filled-label">Select Portfolio</InputLabel> */}
                        <Select
                          labelId="demo-simple-select-accNumber-label"
                          id="demo-simple-select-accNumber"
                          sx={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '22px',
                            letterSpacing: '0.01em',
                          }}
                          onChange={handleAccountNumberChange}
                          value={wAccountId}
                        >
                          {wAccountsData?.OAccountID?.map((i: any, index: any) => (
                            <MenuItem value={i.AccountIdentifier} key={i.AccountIdentifier}>
                              {i.AccountIdentifier}
                            </MenuItem>
                          ))}

                        </Select>
                      </FormControl>
                    </Stack>
                  }

                  <FormControl>
                    <RadioGroup
                      name={'duration'}
                      value={values.duration}
                      onChange={(event) => {
                        setDuration(event.currentTarget.value);
                        setFieldValue('duration', event.currentTarget.value);
                      }}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 1,
                        mb: 2,
                      }}>
                      <FormControlLabel value="AsOnDate" control={<BpRadio />} label="As On Date" />
                      <FormControlLabel value="betweenDates" control={<BpRadio />} label="Between Dates" />
                    </RadioGroup>
                  </FormControl>
                  {
                    duration == "AsOnDate" &&
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="You are requesting client statement"
                        format="DD-MM-YYYY"
                        value={dayjs(dates)}
                        maxDate={dayjs(currentDate)}
                        onChange={(date: any) => {
                          setDates(date.format("YYYY-MM-DD"))
                          setFieldValue('date', date)
                        }}
                      />
                    </LocalizationProvider>
                  }
                  {
                    duration == "betweenDates" &&
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="From Date"
                          format="DD-MM-YYYY"
                          value={dayjs(cg_fromDates)}
                          maxDate={dayjs(currentDate)}
                          onChange={(date: any) => {
                            setCg_fromDates(date.format("YYYY-MM-DD"))
                            setFieldValue('cg_fromDate', date)
                          }}
                          sx={{ mb: 2 }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="To Date"
                          format="DD-MM-YYYY"
                          value={dayjs(cg_toDates)}
                          maxDate={dayjs(currentDate)}
                          onChange={(date: any) => {
                            setCg_toDates(date.format("YYYY-MM-DD"))
                            setFieldValue('cg_todate', date)
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  }
                </Stack>
              </ReportSectionContainer>
              <ReportSectionContainer>
                <Stack>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      letterSpacing: '0.01em',
                    }}>
                    Select Portfolio
                  </Typography>
                  <FormControl sx={{ m: 1, minWidth: 500 }}>
                    {/* <InputLabel id="demo-simple-select-filled-label">Select Portfolio</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '22px',
                        letterSpacing: '0.01em',
                      }}
                      onChange={handleChange}
                      value={portfolio}
                    >
                      <MenuItem value={1}>BugleRock</MenuItem>
                      <MenuItem value={2}>Held Away</MenuItem>
                      <MenuItem value={3}>Combined</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </ReportSectionContainer>
              <ReportSectionContainer>
                <Stack>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      letterSpacing: '0.01em',
                    }}>
                    Report Selection
                  </Typography>
                  <FormMultiSelect
                    name={'reportOptions'}
                    onChange={(e) => {
                      const value = e.target.value as Array<number>;
                      const allIdValue: number = reportSelection.find(
                        (option: { label: string; value: string }) =>
                          option.label.toLowerCase() === 'all'
                      ).value;
                      if (
                        value.length < values.reportOptions.length &&
                        value.indexOf(allIdValue) !== -1
                      ) {
                        value.splice(value.indexOf(allIdValue), 1);
                        setFieldValue('reportOptions', value);
                      } else if (value.indexOf(allIdValue) !== -1) {
                        setFieldValue(
                          'reportOptions',
                          reportSelection.map((each: any) => each.value)
                        );
                      } else if (
                        value.length === reportSelection.length - 1 &&
                        values.reportOptions.indexOf(allIdValue) === -1
                      ) {
                        setFieldValue('reportOptions', [...value, allIdValue]);
                      } else if (
                        value.indexOf(allIdValue) === -1 &&
                        values.reportOptions.indexOf(allIdValue) !== -1
                      ) {
                        setFieldValue('reportOptions', []);
                      } else {
                        setFieldValue('reportOptions', value);
                      }
                    }}
                    options={reportSelection}
                    placeholder={'Select here'}
                  />

                  <Stack>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position">
                        <FormControlLabel
                          value={Boolean(values.redeemedSchemesFlg)}
                          checked={Boolean(values.redeemedSchemesFlg)}
                          onChange={(_, checked) => {
                            setFieldValue('redeemedSchemesFlg', Number(checked));
                          }}
                          control={<Checkbox />}
                          label="Redeemed Schemes"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={Boolean(values.transactionHistoryFlg)}
                          checked={Boolean(values.transactionHistoryFlg)}
                          onChange={(_, checked) => {
                            setFieldValue('transactionHistoryFlg', Number(checked));
                          }}
                          control={<Checkbox />}
                          label="Transaction History (since inception)"
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>
                  </Stack>
                </Stack>
              </ReportSectionContainer>
              <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
                <MFSubmitButton label="Download" loadingEnable={loading} />
              </Stack>
            </Form>
          )}
        </Formik>
      </ReportsRightLayout>
    </>
  );
};

export default ClientStatement;